import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=0412aa0d&scoped=true&"
import script from "./BaseInput.vue?vue&type=script&lang=js&"
export * from "./BaseInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=0412aa0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412aa0d",
  null
  
)

export default component.exports